import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm, Field, change, touch } from 'redux-form'
import { FormGroup, FormControl, Row, Col } from 'react-bootstrap'
import { default as _ } from 'underscore'
import { connect } from 'react-redux'
import validation from '../../../constants/validation'
import { getCarDataFormValues, stopLoading, storeCarDataFormValues, storeCarDataFormValuesPartially } from './actions'
import { fetchMakes } from './../checkoutContent/actions'
import Loading from '../../../components/Loading'
import Select from '../../../components/Select'

import { configuration } from '../../../configuration'

const { REQUIRED_FIELD } = validation

const validate = values => {
  const errors = {}
  if (!values.carYear || values.carYear === '') {
    errors.carYear = REQUIRED_FIELD;
  } /*else if (/^\d{4}$/.test(values.carYear)) {
    errors.carYear = YEAR_4_DIGITS
  } else if (values.carYear > (new Date()).getFullYear()) {
    errors.carYear = OLD_DATE_VALUE;
  }*/
  if (!values.carMake || values.carMake === '') {
    errors.carMake = REQUIRED_FIELD;
  }
  if (!values.carModel || values.carModel === '') {
    errors.carModel = REQUIRED_FIELD;
  }
  if (!values.carEngine || values.carEngine === '') {
    errors.carEngine = REQUIRED_FIELD;
  }
  return errors;
}

const form = reduxForm({
  form: 'carDataForm',
  validate,
});

// Render components
const renderInputField = (field) => {
  return (
    <span>
      <FormControl {...field.input} disabled={field.disabled} componentClass={field.componentClass || 'input'}>
        {field.children || ''};
      </FormControl>
      {field.meta.touched && ((field.meta.error && <span className="text-danger">{field.meta.error}</span>) || (field.meta.warning && <span className="text-warning">{field.meta.warning}</span>))}
    </span>
  );
}

class CarDataForm extends React.Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    carDataStore: PropTypes.shape({
      carDataData: PropTypes.object,
    }).isRequired,
    getCarDataFormValues: PropTypes.func.isRequired,
    fetchMakes: PropTypes.func.isRequired,
    carDataForm: PropTypes.shape({
      values: PropTypes.object,
    }).isRequired,
    loadFormValue: PropTypes.func.isRequired,
    checkoutStore: PropTypes.shape({
      nonForfaitBudget: PropTypes.object,
    })
  }

  componentWillMount() {
    this.props.fetchMakes();
  }
  handleFormSubmit(values) {
  }

  componentWillReceiveProps(props) {
    let carData;
    if (props.currentUser !== null && props.carDataStore.carDataData === null && this.props.makes) {
      carData = {
        carMake: props.currentUser.make,
        carEngine: [props.currentUser.engine, props.currentUser.fuel, props.currentUser.engineId] + "",
        carModel: props.currentUser.model,
        carYear: props.currentUser.year,
        carVin: props.currentUser.vim,
      }
      const make = _.find(this.props.makes, { make: props.currentUser.make }) || { models: [] }
      const model = _.find(make.models, { model: props.currentUser.model }) || { engines: [] }
      const engine = _.find(model.engines, { engine: props.currentUser.engine }) || {}
      //TODO: Hay que refactorizar esta parte
      if (make.make && model.model && engine.engine) {
        props.storeCarDataFormValues({
          ...carData,
        });
      }
      else {
        props.storeCarDataFormValuesPartially({
          carMake: make.make || '',
          carEngine: engine.engine || '',
          carModel: model.model || '',
          carYear: props.currentUser.year,
          carVin: props.currentUser.vim || '',
        });
      }
      props.stopLoading();
    } else if (props.currentUser !== null && props.carDataStore.carDataData !== null) {
      // Load form data 
      _.each(Object.keys(props.carDataStore.carDataData), (property) => {
        if (props.carDataStore.carDataData[property]) {
          this.props.loadFormValue('carDataForm', property, props.carDataStore.carDataData[property])
        }
      });
    } else if (props.currentUser === null && props.carDataStore.carDataData !== null) {
      _.each(Object.keys(props.carDataStore.carDataData), property =>
        this.props.loadFormValue('carDataForm', property, props.carDataStore.carDataData[property]));
    }
    else if (props.makes && props.finishedLoad) {
      //Load form options
      props.stopLoading();
    }
  }

  changePetrolToGasolina(fuel) {
    if (fuel.toLowerCase() === 'petrol') {
      return 'Gasolina';
    } else {
      return fuel;
    }
  }

  render() {
    const loading = this.props.carDataStore.loading;
    const { handleSubmit } = this.props;

    // Store values
    // const carDataData = this.props.carDataStore.carDataData || {};
    // Form values
    const carDataFormValues = this.props.carDataForm.values || {};
    // Form Options
    const carDataOptions = this.props.makes || {};

    // Form Values
    const carMakeValue = carDataFormValues.carMake;
    const carModelValue = carDataFormValues.carModel;
    const carEngineValue = carDataFormValues.carEngine;

    // Select options
    const carMakeOpts = _.map(carDataOptions, (e) => <option key={e._id} value={e.make}>{e.make}</option>);
    const selectedMake = _.findWhere(carDataOptions, { make: carMakeValue }) || {};
    const carModelOpts = _.map(selectedMake.models || [], (e) => <option key={e._id} value={e.model}>{e.model}</option>);
    const carModelsData = _.map(selectedMake.models || [], e => e)
    const selectedModel = _.findWhere(carModelsData || [], { model: carModelValue }) || {};
    const carEngineOpts = _.map(selectedModel.engines || [], (e) => <option key={e._id} value={[e.engine, e.fuel, e.engineId]}>{e.engine} {this.changePetrolToGasolina(e.fuel)}</option>);
    const carYearOpts = [];
    for (let i = (new Date()).getFullYear(); i >= 1980; i--) {
      carYearOpts.push(<option key={i} value={i}>{i}</option>);
    }

    let render = <Loading />;

    if (!loading) {
      render = (
        <form onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
          <br />
          <Row>
            <Col md={6} sm={12}>
              <FormGroup controlId="carMake">
                <Field name="carMake" componentClass="select" component={Select} value={carMakeValue}>
                  <option value="">Marca</option>
                  {carMakeOpts}
                </Field>
              </FormGroup>
            </Col>
            <Col md={6} sm={12}>
              <FormGroup controlId="carModel">
                <Field name="carModel" disabled={!carMakeValue} componentClass="select" component={Select} value={carModelValue}>
                  <option value="">{configuration().modelField ? configuration().modelField : 'Modelo'}</option>
                  {carModelOpts}
                </Field>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6} sm={12}>
              <FormGroup controlId="carEngine">
                <Field name="carEngine" disabled={!carMakeValue || !carModelValue} componentClass="select" component={Select}>
                  <option value="">{configuration().engineField ? configuration().engineField : 'Motor'}</option>
                  {carEngineOpts}
                </Field>
              </FormGroup>
            </Col>
            <Col md={6} sm={12}>
              <FormGroup controlId="carYear">
                <Field name="carYear" disabled={!carMakeValue || !carModelValue || !carEngineValue} componentClass="select" component={Select}>
                  <option value="">Año de matriculación</option>
                  {carYearOpts}
                </Field>
              </FormGroup>
            </Col>
          </Row>
        </form>
      );
    }
    return (
      <span>
        {render}
      </span>
    );
  }
}

const mapStateToProps = state => ({
  carDataStore: state.checkout.carData,
  carDataForm: state.form.carDataForm || {},
  checkoutStore: state.checkout.checkoutRoot,
  makes: state.make.makes,
  currentUser: state.checkout.checkoutContent.currentUser,
  finishedLoad: state.checkout.checkoutContent.finishedLoad
});

const bindActions = dispatch => ({
  getCarDataFormValues: () => dispatch(getCarDataFormValues()),
  loadFormValue: (form, field, value) => dispatch(change(form, field, value)),
  stopLoading: () => dispatch(stopLoading()),
  touchFormFiels: (form, fields) => dispatch(touch(form, ...fields)),
  fetchMakes: () => dispatch(fetchMakes()),
  storeCarDataFormValues: values => dispatch(storeCarDataFormValues(values)),
  storeCarDataFormValuesPartially: values => dispatch(storeCarDataFormValuesPartially(values)),
});

export default connect(mapStateToProps, bindActions)(form(CarDataForm));



// WEBPACK FOOTER //
// ./src/workflow/checkout/carData/carDataForm.component.js